module.exports = __webpack_public_path__ + "img/lewis.c5fbf39.png";